import { FC, ReactElement } from 'react'
import { Link } from 'react-router-dom'

import { ASSETS } from '../../../../constants'
import Image from '../../../atoms/images/image'
import './mainBanner.css'

const MainBanner: FC = (): ReactElement => {
  return (
    <div className="banner banner-onthehub">
      <div className="banner-text-wrapper">
        <div className="banner-text">
          <span className="italian">Welcome to</span>
          <span className="title roman">OnTheHub</span>
          <hr />
          <p>
            Students and faculty <span className="heavy">save up to 90%</span> on all academic software with OnTheHub!
          </p>
          <Link to="/school">
            <button className="light">Find Your School</button>
          </Link>
        </div>
      </div>
      <div className="banner-content">
        <Image
          disableLazy={true}
          className="laptop"
          src={`${ASSETS}/banners/carousel-banners/1-top-slider-laptop.png`}
          alt="Laptop With OnTheHub eStore"
          size={{ width: 349, height: 204 }}
        />
        <Image
          disableLazy={true}
          className="back-image"
          src={`${ASSETS}/banners/carousel-banners/1-top-slider-boxshots.png`}
          alt="Blue Circle with Software Boxshots"
          size={{ width: 794, height: 589 }}
        />
      </div>
    </div>
  )
}

export default MainBanner
